import Vue from 'vue'

import '@/app/plugins/vuetify'
import router from '@/app/router'
import store from '@/app/store'
import './registerServiceWorker'
import vuetify from '@/app/plugins/vuetify';

import { createPinia, PiniaVuePlugin } from 'pinia';

import '@/app/bootstrap'

import App from './App.vue'

Vue.config.productionTip = false

Vue.config.keyCodes.f3 = 112;

const pinia = createPinia();
Vue.use(PiniaVuePlugin);

new Vue({
  router,
  store,
  vuetify,
  pinia,
  render: h => h(App)
}).$mount('#app')
